import { GET, POST, PUT } from "./_config";

export const notifyPartyListApi = async (query: string) =>
  await GET(`/notify-party?${query || ""}`, true);

export const createNotifyPartyApi = async (body: any) =>
  await POST(`/notify-party`, body, true);

export const updateNotifyPartyApi = async (notifyPartyId: string, body: any) =>
  await PUT(`/notify-party?id=${notifyPartyId}`, body, true);

export const updateNotifyPartyStatusApi = async (body: any) =>
  await POST(`/notify-party/update-status`, body, true);

export const getNotifyPartyByIdApi = async (notifyPartyId: string) =>
  await GET(`/notify-party/id/${notifyPartyId}`, true);

export const getNotifyPartyNameListApi = async (query?: string) =>
  await GET(`/notify-party/list${query ? `?${query}` : ""}`, true);

const NotifyPartyService = {
  notifyPartyListApi,
  createNotifyPartyApi,
  updateNotifyPartyApi,
  updateNotifyPartyStatusApi,
  getNotifyPartyByIdApi,
  getNotifyPartyNameListApi,
};

export default NotifyPartyService;
